import React from 'react'
import { Link } from 'react-router-dom'
import TabTittle from '../components/TabTittle'

function TothoProdankari() {
    TabTittle('তথ্য প্রদানকারী কর্মকর্তা | জেলা পরিষদ, রাজশাহী।')

    return (
        <>
            <div className='colam'>
                <div className="pageTittle">
                    <h2><Link to="/">Hme</Link>/তথ্য প্রদানকারী কর্মকর্তা</h2>
                </div>
                <div className="newcContent">
                    <div className="tittle">
                        <h1>তথ্য প্রদানকারী কর্মকর্তা</h1>
                    </div>
                    <div className="pdf-viewer" style={{ width: '100%', height: '800px' }}>
                        <iframe
                            src={`${process.env.PUBLIC_URL}/notice/CamScanner 06-11-2026 09.30.pdf`}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            title="তথ্য প্রদানকারী কর্মকর্তা"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TothoProdankari
